<template>
  <div id="home-tendencias">
    <section class="sc-main">
      <div class="section-title">
        <h3 class="mb-3 mb-md-2">Tendencias en Instagram</h3>
        <a :href="'https://www.instagram.com/' + $instagram" class="mos-btn">
          <i class="fa-brands fa-instagram"></i>tulumoutdoor
        </a>
      </div>
      <div class="instagram-feed-wrapper">
        <a v-for="(item, index) in instagramMedia" :href="item.permalink" target="_blank" class="instagram-feed-item" v-bind:key="index"> 
          <img :src="item.media_url" alt="">
        </a>
      </div>
    </section>
  </div>
</template>
<script>
import mobileChecker from '@/mixins/mobileChecker'

export default {
  mixins: [mobileChecker],
  data() {
    return {
      instagramMedia: []
    }
  },
  mounted() {
    this.getInstagramMedia()
  },
  methods: {
    getInstagramMedia() {
      this.$store.dispatch('getInstagramMedia').then((data) => {
        if (this.isMobile || this.isTablet) {
          this.instagramMedia = data.data.slice(0, 6)
        } else {
          this.instagramMedia = data.data.slice(0, 8)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
#home-tendencias {
  width: 100%;
  background-color: $color-quinary;

  .sc-main {
    width: 100%;
    padding: 5rem 10%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 767px) {
      padding: 4rem 0 1rem 0;
    }

    .section-title {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 1rem;
    }

    h3 {
      font-weight: 600;
      text-align: center;
    }

    .mos-btn {
      i {
        font-size: 22px;
        margin-right: 0.5rem;
      }

      @media (max-width: 767px) {
        width: 100%;
        justify-content: center;
        padding: 0.75rem;
      }
    }
  }

  .instagram-feed-wrapper{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 1rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
    }
    @media (min-width: 769px) {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }
    @media (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }

    .instagram-feed-item{
      height: 270px;
      aspect-ratio: 1/1;
      overflow: hidden;

      @media (max-width: 768px) {
        width: 100%;
        height: auto;
      }
      @media (min-width: 769px) {
        width: 100%;
        height: auto;
      }
      @media (min-width: 992px) {
        height: 180px;
        width: auto;
      }
      @media (min-width: 1292px) {
        height: 240px;
        width: auto;
      }

      &:hover {
        img{
          filter: sepia(0.2);
          transform: scale(1.02);
          transition: all 0.4s ease-in-out;
        }
      }
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
